import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToArray' })
export class EnumToArray implements PipeTransform {
  transform(value: any): any {
    const array = new Array<any>();
    for (const item in value) {
      if (isNaN(Number(item))) {
        array.push({
          name: value[item].replace("_", " "), code: item
        });
      }
    }
    return array;
  }
}
